export default "__VITE_ASSET__Cg7VtYX6__"